let pressedKeys = {};
const KEY_CODES = {
    32: "SPACE",
    37: "LEFT",
    38: "UP",
    39: "RIGHT",
    40: "DOWN"
};

window.addEventListener('blur', function () {
    pressedKeys = {};
});

function setKey(event, status) {
    let key = event.keyCode;

    pressedKeys[KEY_CODES[key]||String.fromCharCode(key)] = status;
}

document.addEventListener('keydown', function (e) {
    setKey(e, true);
});

document.addEventListener('keyup', function (e) {
    setKey(e, false);
});

export default {
    isDown: function (key) {
        return pressedKeys[key.toUpperCase()];
    }
};
